export { default as EnTabs } from './EnTabs.vue';
